var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 1.60001C6.72694 1.60001 5.50604 2.10572 4.60586 3.00589C3.70569 3.90607 3.19998 5.12697 3.19998 6.40001V9.26881L2.63438 9.83441C2.52253 9.94629 2.44636 10.0888 2.41551 10.244C2.38466 10.3991 2.4005 10.56 2.46103 10.7061C2.52157 10.8523 2.62408 10.9772 2.75561 11.0651C2.88714 11.153 3.04178 11.2 3.19998 11.2H12.8C12.9582 11.2 13.1128 11.153 13.2443 11.0651C13.3759 10.9772 13.4784 10.8523 13.5389 10.7061C13.5995 10.56 13.6153 10.3991 13.5844 10.244C13.5536 10.0888 13.4774 9.94629 13.3656 9.83441L12.8 9.26881V6.40001C12.8 5.12697 12.2943 3.90607 11.3941 3.00589C10.4939 2.10572 9.27301 1.60001 7.99998 1.60001ZM7.99998 14.4C7.36346 14.4 6.75301 14.1472 6.30292 13.6971C5.85283 13.247 5.59998 12.6365 5.59998 12H10.4C10.4 12.6365 10.1471 13.247 9.69703 13.6971C9.24695 14.1472 8.6365 14.4 7.99998 14.4Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.272711f7360cdf858501f10eb9b52fdc.svg";
export { ForwardRef as ReactComponent };